var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInbound01 = function SvgIconInbound01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_inbound-01_svg2__a",
    x1: 0,
    x2: 100,
    y1: 62.5,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_inbound-01_svg2__a",
    id: "icon_inbound-01_svg2__b",
    x1: 35.71,
    x2: 64.29,
    y1: 30.36,
    y2: 30.36
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.39 25a13.64 13.64 0 0 0-12.44 8.08L.31 59.26c-.25.52-.31 1-.31 1.45v28.57c0 5.87 4.84 10.71 10.71 10.71h78.57c5.87 0 10.71-4.84 10.71-10.71V60.71c0-.48-.09-.91-.31-1.45-3.88-8.72-7.76-17.45-11.64-26.18A13.62 13.62 0 0 0 75.6 25h-7.76c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h7.76c2.57 0 4.87 1.5 5.92 3.84l9.4 21.16H74.28a9.11 9.11 0 0 0-8.29 5.36l-3.5 7.77c-.32.71-1 1.15-1.78 1.15H39.28c-.78 0-1.46-.44-1.78-1.15L34 62.5a9.1 9.1 0 0 0-8.29-5.36H9.07l9.4-21.16a6.45 6.45 0 0 1 5.92-3.84h7.76c1.97 0 3.57-1.6 3.57-3.57S34.12 25 32.15 25zM7.14 64.29h18.57c.78 0 1.46.44 1.78 1.15l3.5 7.77a9.1 9.1 0 0 0 8.29 5.36h21.43A9.11 9.11 0 0 0 69 73.21l3.5-7.77c.32-.71 1-1.15 1.78-1.15h18.57v25c0 2.04-1.53 3.57-3.57 3.57H10.71c-2.04 0-3.57-1.53-3.57-3.57z",
    style: {
      fill: "url(#icon_inbound-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0c-1.97 0-3.57 1.6-3.57 3.57v44.95l-4.62-4.62c-1.56-1.54-3.62-1.43-5.05 0a3.58 3.58 0 0 0 0 5.05l10.71 10.71a3.58 3.58 0 0 0 5.05 0l10.71-10.71a3.58 3.58 0 0 0 0-5.05 3.58 3.58 0 0 0-5.05 0l-4.62 4.62V3.57A3.557 3.557 0 0 0 50 0",
    style: {
      fill: "url(#icon_inbound-01_svg2__b)"
    }
  }));
};
export default SvgIconInbound01;